module.exports = __webpack_public_path__ + "static/img/4-3.56329d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-go/mobile/4-3.png
// module id = s9tr
// module chunks = 12